import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Keep callers compatible while all authentication entry points use the page.
export default function LoginModal({ open }) {
  const location = useLocation();
  return open ? <Navigate replace to={`/login?returnTo=${encodeURIComponent(location.pathname + location.search + location.hash)}`} /> : null;
}
